// [NEW FILE] Reporting-manager resolution queue (backend migration 010).
//
// When an employee import has a "Reporting To" *name* (not an employee ID) that matches nobody,
// or matches more than one person, the backend does not guess. It keeps the row in
// employee_reporting_resolution with status PENDING, and HR decides here:
//   GET  /employee-reporting-resolutions?status=PENDING|RESOLVED|DISMISSED
//   POST /employee-reporting-resolutions/{id}/resolve  { manager_employee_id, effective_from?, reason }
//   POST /employee-reporting-resolutions/{id}/dismiss  { reason }   (no manager on purpose)
// Permission: employee.manage at organisation scope (HR / Admin).
import api from "./api";
import { ok, isoUtc, reasonOf, getMe, can, ORG_SCOPES, rememberName } from "./core";

export const RESOLUTION_STATUSES = ["PENDING", "RESOLVED", "DISMISSED"];

const toResolution = (r) => {
  rememberName(r.employee_id, r.employee_name);
  return {
    id: r.resolution_id,
    employeeId: r.employee_id,
    employeeName: r.employee_name || r.employee_id,
    employeeEmail: r.official_email || "",
    managerNameInFile: r.manager_name_source,
    status: r.resolution_status,
    resolvedManagerId: r.resolved_manager_employee_id || null,
    resolvedAt: isoUtc(r.resolved_at),
    resolvedBy: r.resolved_by_employee_id || null,
    note: r.resolution_note || "",
    createdAt: isoUtc(r.created_at),
  };
};

export async function canResolveReporting() {
  const me = await getMe();
  return can(me, "employee.manage", ORG_SCOPES);
}

export async function listReportingResolutions(status = "PENDING") {
  const rows = [];
  for (let offset = 0; offset < 5000; offset += 500) {
    const { data } = await api.get("/employee-reporting-resolutions", { params: { status, limit: 500, offset } });
    rows.push(...data);
    if (data.length < 500) break;
  }
  return ok(rows.map(toResolution));
}

export async function resolveReporting(resolutionId, { managerId, effectiveFrom, reason }) {
  const { data } = await api.post(`/employee-reporting-resolutions/${resolutionId}/resolve`, {
    manager_employee_id: managerId,
    effective_from: effectiveFrom || null,
    reason: reasonOf(reason, "Reporting manager confirmed after employee import"),
  });
  return ok(data);
}

export async function dismissReporting(resolutionId, reason) {
  const { data } = await api.post(`/employee-reporting-resolutions/${resolutionId}/dismiss`, {
    reason: reasonOf(reason, "No reporting manager for this employee"),
  });
  return ok(data);
}
